import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../redux-store/reducers';
import { getDPNameList } from '../redux-store/actions/userManagement';
import { DPNameType } from '../redux-store/types/api-types';

/**
 * Returns the admin-created Broker / Depository Participant (DP) name list from redux.
 *
 * The list is served by the backend (`/onboarding/amc/getDPnamelist`) and cached in the
 * `dpNameList` slice. It is fetched once (when empty) and shared across the portal, instead
 * of every component calling the API on mount.
 */
export const useDPNameListData = (): DPNameType[] => {
  const dispatch = useDispatch();
  const dpNameList = useSelector((state: RootStateType) => state.dpNameList.dpNameList);

  useEffect(() => {
    (async function () {
      try {
        if (dpNameList.length === 0) {
          await dispatch(getDPNameList());
        }
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, [dpNameList, dispatch]);

  return dpNameList;
};
